import { RootState, SubscriptionType, SubscriptionWithGetIT } from "../../../../models";
import { SubscriptionListingState } from "../../../../models/state";

export const getSubscriptionListingState = (state: RootState): SubscriptionListingState =>
    state.subscriptionListing || {};

export const getSubscriptions: (state: RootState) => SubscriptionWithGetIT[] = (state: RootState) =>
    getSubscriptionListingState(state).subscriptions || [];

export const getSubscriptionsYoung: (state: RootState) => SubscriptionWithGetIT[] = (state: RootState) =>
    getSubscriptionListingState(state).subscriptionsYoung || [];

export const getHiddenSubscriptionsOfferingCodes: (state: RootState) => SubscriptionType[] = (state: RootState) =>
    getSubscriptionListingState(state).hiddenSubscriptionsOfferingCodes || [];

export const getHiddenSubscriptionsYoungOfferingCodes: (state: RootState) => SubscriptionType[] = (state: RootState) =>
    getSubscriptionListingState(state).hiddenSubscriptionsYoungOfferingCodes || [];

export const getTeliaTryggSubscriptions: (state: RootState) => SubscriptionWithGetIT[] = (state: RootState) =>
    getSubscriptionListingState(state).teliaTryggSubscriptions || [];
